import React, { useState } from 'react';
import { Home, Grid3X3, Sparkles, Calendar } from 'lucide-react';
import MiniAppHomePage from './MiniAppHomePage';
import WorksCategory from './WorksCategory';
import DiscoverPage from './DiscoverPage';
import BookingPage from './BookingPage';

const MiniApp = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const renderContent = () => {
    switch(activeTab) {
      case 'home':
        return <MiniAppHomePage onVideoPlayingChange={setIsVideoPlaying} />;
      case 'category':
        return <WorksCategory />;
      case 'discover':
        return <DiscoverPage />;
      case 'booking':
        return <BookingPage />;
      default:
        return <MiniAppHomePage onVideoPlayingChange={setIsVideoPlaying} />;
    }
  };

  return (
    <div className="min-h-screen bg-white relative">
      {/* Main Content */}
      <div>
        {renderContent()}
      </div>

      {/* Bottom Navigation - Hide when video is playing */}
      {!isVideoPlaying && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="flex justify-around items-center py-3">
          <button 
            onClick={() => setActiveTab('home')}
            className={`flex flex-col items-center gap-1 px-4 py-1 ${activeTab === 'home' ? 'text-black' : 'text-gray-400'}`}
          >
            <Home className="w-5 h-5" />
            <span className="text-xs">HOME</span>
          </button>
          <button 
            onClick={() => setActiveTab('category')}
            className={`flex flex-col items-center gap-1 px-4 py-1 ${activeTab === 'category' ? 'text-black' : 'text-gray-400'}`}
          >
            <Grid3X3 className="w-5 h-5" />
            <span className="text-xs">作品分类</span>
          </button>
          <button 
            onClick={() => setActiveTab('discover')}
            className={`flex flex-col items-center gap-1 px-4 py-1 relative ${activeTab === 'discover' ? 'text-black' : 'text-gray-400'}`}
          >
            <Sparkles className="w-5 h-5" />
            <span className="text-xs">发现精彩</span>
          </button>
          <button 
            onClick={() => setActiveTab('booking')}
            className={`flex flex-col items-center gap-1 px-4 py-1 ${activeTab === 'booking' ? 'text-black' : 'text-gray-400'}`}
          >
            <Calendar className="w-5 h-5" />
            <span className="text-xs">需求咨询</span>
          </button>
        </div>
      </div>
      )}
    </div>
  );
};

export default MiniApp;
